<template>
    <div>
        <div class="box"></div>
    </div>
</template>
<script>
    export default {
        props: [],
        data() {
            return {}
        },
        created() {},
        methods: {}
    }
</script>
<style scoped>
    .box {
        height: 30px;
        background: linear-gradient(180deg, rgba(26, 115, 115, 0.4) 0%, rgba(35, 128, 128, 0.2) 48%, rgba(52, 150, 150, 0) 100%);
    }
</style>